import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { auth, db } from "../../firebase/config";

export const createDayJob = async (jobData) => {
  if (!auth.currentUser?.uid) {
    throw new Error("User must be logged in to post a day job.");
  }

  const payload = {
    ownerId: auth.currentUser.uid,
    title: jobData.title?.trim() || "",
    description: jobData.description?.trim() || "",
    category: jobData.category || "general_labor",
    payType: jobData.payType || "flat",
    payAmount:
      jobData.payType === "quote" || jobData.payAmount === "" || jobData.payAmount == null
        ? null
        : Number(jobData.payAmount),
    duration: jobData.duration?.trim() || "",
    dateNeeded: jobData.dateNeeded || "",
    locationText: jobData.locationText?.trim() || "",
    city: jobData.city || "",
    state: jobData.state || "",
    lat:
      typeof jobData.lat === "number" && !Number.isNaN(jobData.lat)
        ? jobData.lat
        : null,
    lng:
      typeof jobData.lng === "number" && !Number.isNaN(jobData.lng)
        ? jobData.lng
        : null,
    status: "open",
    acceptedWorkerId: null,
    images: [],
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  };

  return addDoc(collection(db, "dayJobs"), payload);
};